import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Assignment } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

//servicios
import { wsGetAll } from 'services/WService.js';

const styles = {
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  },
  size: {
    fontSize: '4.4rem'
  }
};
const useStyles = makeStyles(styles);

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false },
  { Header: 'Usuario', accessor: 'codproduct' },
  { Header: 'DNI', accessor: 'name' },
  { Header: 'Fecha', accessor: 'create' },
  { Header: 'Error', accessor: 'error' },
  { Header: 'Detalle', accessor: 'detail' },
  { Header: '', accessor: 'actions', excelEnabled: false }
];

export default function Log() {
  const classes = useStyles();

  const [logs, setLogs] = useState([]);

  async function listLogs() {
    let response = await wsGetAll('base/log');
    if (response.success) setLogs(response.data);
  }

  useEffect(() => {
    listLogs();
  }, []);

  return (
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="primary" icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Listado de Logueos</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Logueos"
              defaultWidth={1200}
              indexRow={[0, 1, 2, 3, 4, 6]}
              widthRow={[80, 350, 100, 200, 350, 10]}
              columns={columns}
              data={logs.map((log, i) => {
                return {
                  num: i + 1,
                  user: log.SlpName,
                  dni: log.dni,
                  create: log.created_at,
                  error: log.error,
                  detail: log.detail,
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
}
